// extracted by mini-css-extract-plugin
module.exports = {"login-page":"style-m__login-page__QNm_q","login-success":"style-m__login-success__3wU7R"};